<div class="header">
  <ion-button
    fill="clear"
    class="close ion-no-padding"
    (click)="closeModal()"
    color="white"
  >
    <ion-icon slot="icon-only" name="close" color="white"></ion-icon>
  </ion-button>
</div>

<div class="content">
  <!-- iOS nativo: thumbnail + play -->
  <div *ngIf="noticia.Tipo === 2 && isIos" class="video-thumbnail-detail" (click)="openYouTubeApp()">
    <ion-img
      [src]="thumbnailUrl"
      class="thumbnail-img"
      (ionError)="$any($event.target).src = imgPlaceholderYt"
    ></ion-img>
    <div class="play-button-overlay">
      <ion-icon name="play-circle" class="play-icon"></ion-icon>
    </div>
  </div>

  <!-- Web y Android: iframe -->
  <div *ngIf="noticia.Tipo === 2 && !isIos">
    <iframe
      width="92%"
      height="200"
      [src]="noticia.Recurso | videoSan"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>

  <ion-card
    class="card-image"
    *ngIf="noticia.Tipo === 1"
    type="button"
    button
    (click)="openModalZoom(noticia.Recurso)"
  >
    <img
      class="banner"
      [src]="noticia.Recurso"
      (error)="onImageError($event)"
    />
  </ion-card>

  <div class="head">
    <div>
      <p class="title-new">
        <b>{{ noticia.Titulo }}</b>
      </p>
      <p class="date-new">{{ noticia.FechaVigenciaInicial }}</p>
    </div>
    <div>
      <ion-buttons>
        <ion-button
          slot="primary"
          class="less-font"
          mode="md"
          (click)="decreaseFont()"
          >A<sup>-</sup></ion-button
        >
        <ion-button
          slot="secondary"
          class="more-font"
          mode="md"
          (click)="increaseFont()"
          >A<sup>+</sup></ion-button
        >
      </ion-buttons>
    </div>
  </div>

  <div class="content-new">
    <p
      [innerHTML]="noticia.Descripcion | htmlSeguro"
      (click)="urlRedirect(noticia.Descripcion)"
      [ngStyle]="{ fontSize: fontSize + 'px' }"
      class="detail"
    ></p>
  </div>
</div>
